import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import mutations from "./mutations";
import actions from "./actions";
import createPersistedState from "vuex-persistedstate";
export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  modules: {
    mutations: mutations
  },
  actions: actions
});